import { render } from "./mainnav.vue?vue&type=template&id=5d2523ca&scoped=true"
import script from "./mainnav.vue?vue&type=script&lang=js"
export * from "./mainnav.vue?vue&type=script&lang=js"

import "./mainnav.vue?vue&type=style&index=0&id=5d2523ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d2523ca"]])

export default __exports__